import { useTranslation } from 'react-i18next';
import { Row, day } from './bodyParts';

export interface StockTakeDetail {
  id: string;
  reference: string;
  status: string;
  notes?: string | null;
  createdAt: string;
  startedAt?: string | null;
  completedAt?: string | null;
  location?: { name: string } | null;
  items: Array<{
    id: string;
    expectedQty: number;
    countedQty?: number | null;
    variance?: number | null;
    product?: { name: string } | null;
  }>;
}

/** Read-only stock take for the record viewer (POS-I239). */
export function StockTakeDetailBody({ data }: { data: StockTakeDetail }) {
  const { t } = useTranslation('records');
  return (
    <div className="space-y-5 text-sm">
      <dl className="space-y-1.5">
        <Row label={t('rvDate')}><span dir="ltr">{day(data.createdAt)}</span></Row>
        {data.location?.name && <Row label={t('rvLocation')}>{data.location.name}</Row>}
        {data.startedAt && <Row label={t('rvStarted')}><span dir="ltr">{day(data.startedAt)}</span></Row>}
        {data.completedAt && <Row label={t('rvCompleted')}><span dir="ltr">{day(data.completedAt)}</span></Row>}
        {data.notes && <Row label={t('rvNotes')}>{data.notes}</Row>}
      </dl>
      {data.items.length === 0 ? (
        <p className="text-muted-foreground">{t('rvNoItems')}</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b text-xs text-muted-foreground">
                <th className="py-1 text-start font-medium">{t('rvProduct')}</th>
                <th className="py-1 text-end font-medium">{t('rvExpected')}</th>
                <th className="py-1 text-end font-medium">{t('rvCounted')}</th>
                <th className="py-1 text-end font-medium">{t('rvVariance')}</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((i) => (
                <tr key={i.id} className="border-b align-top last:border-0">
                  <td className="py-1.5 break-words">{i.product?.name}</td>
                  <td className="py-1.5 text-end tabular-nums" dir="ltr">{i.expectedQty}</td>
                  <td className="py-1.5 text-end tabular-nums" dir="ltr">{i.countedQty ?? '—'}</td>
                  <td className="py-1.5 text-end tabular-nums" dir="ltr">{i.variance ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
